import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { ShopContext } from '../../Context/ShopContext';
import { MdOutlineShoppingCart } from "react-icons/md";
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the side menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Function to close the side menu
  const closeMenu = () => {
    setIsOpen(false);
  };

  // Use location hook to track route changes
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Function to handle mouse leave (close the side menu)
  const handleMouseLeave = () => {
    setIsOpen(false);
  };

   // Get cart data from context
   const { cartItems } = useContext(ShopContext);

  // Calculate the total number of items in the cart
  const getTotalCartItems = () => {
    let totalItem = 0;
    for (const key in cartItems) {
      if (cartItems[key].quantity > 0) {
        totalItem += cartItems[key].quantity;
      }
    }
    return totalItem;
  };

  const totalCartItems = getTotalCartItems();  // Get the total items in the cart

  return (
    <div>
      {/* Navbar */}
      <div className="navbar">
        {/* Hamburger Menu */}
        <div className="hamburger-container" onClick={toggleMenu}>
          <div className={`hamburger-btn ${isOpen ? 'open' : ''}`}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        {/* Cart Button on the Right */}
        <div className="cart-btn-container">
          <Link to="/cart" className="cart-btn">
          <MdOutlineShoppingCart className="cart-icon" />
            {totalCartItems > 0 && (
              <span className="cart-item-count">{totalCartItems}</span>
            )}
          </Link>
        </div>
      </div>

      {/* Side Menu */}
      <div
        className={`side-menu ${isOpen ? 'open' : ''}`}
        onMouseLeave={handleMouseLeave}  // Close the side menu on mouse leave
      >
        <h2>Side Menu</h2>
        {/* Links for navigation */}
        <ul>
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>About</Link>
          </li>
          <li className="categories-dropdown">
            <span>Categories</span>
            <ul className="dropdown-menu">
              <li><Link to="/living-room" onClick={closeMenu}>Living Room</Link></li>
              <li><Link to="/dining-room" onClick={closeMenu}>Dining Room</Link></li>
              <li><Link to="/foyer" onClick={closeMenu}>Foyer</Link></li>
              <li><Link to="/bedroom" onClick={closeMenu}>Bedroom</Link></li>
              <li><Link to="/office" onClick={closeMenu}>Office</Link></li>
              <li><Link to="/children" onClick={closeMenu}>Children</Link></li>
              <li><Link to="/home-decor" onClick={closeMenu}>Home Decor</Link></li>
              <li><Link to="/textiles" onClick={closeMenu}>Textiles</Link></li>
              <li><Link to="/accents" onClick={closeMenu}>Accents</Link></li>
            </ul>
          </li>
          <li>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
          </li>
          <li>
            <Link to="/cart" onClick={closeMenu}>Cart</Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Navbar;
